"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_redux_1 = require("react-redux");
const react_i18next_1 = require("react-i18next");
const _1 = require(".");
const styled_1 = __importDefault(require("@emotion/styled"));
function default_1() {
    const leaderNotice = (0, react_redux_1.useSelector)((state) => state.leaderNotice);
    const noticeLength = leaderNotice.length;
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ style: { marginBottom: '200px' } }, { children: Boolean(leaderNotice.length) ? (leaderNotice
            .slice(0)
            .reverse()
            .map((notice, index) => ((0, jsx_runtime_1.jsx)(_1.NoticeCard, { notice: notice, noticeIndex: noticeLength - index }, `notice_card_${notice.id}_${index}`)))) : ((0, jsx_runtime_1.jsx)(NoNoticeDiv, { children: `${t('아직 작성된 공지사항이 없어요')}~ :)` })) })));
}
exports.default = default_1;
const NoNoticeDiv = styled_1.default.div `
  padding: 40px 20px 146px;
  margin-bottom: -200px;
  color: rgba(0, 0, 0, 0.5);
  background-color: white;
`;
